import * as yup from 'yup'

const validationSchema = yup.object().shape({
  search_term: yup
    .string()
    .min(3, 'Mínimo 3 caracteres')
    .required('Digite o nome do paciente ou o CPF')
})

export default validationSchema
